import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Select,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../../../translate/i18n";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  dialogContent: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  formControl: {
    width: "100%",
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
  }
}));

export function ModalAddTicketStatus({ open, onClose, onSave, onUpdate, node }) {
  const classes = useStyles();
  const [status, setStatus] = useState("closed");
  const [name, setName] = useState("");

  useEffect(() => {
    if (node) {
      setName(node.data?.name || i18n.t("flowBuilder.editor.nodes.ticketStatus.name"));
      setStatus(node.data?.status || "closed");
    } else {
      setName(i18n.t("flowBuilder.editor.nodes.ticketStatus.name"));
      setStatus("closed");
    }
  }, [node]);

  const handleSave = () => {
    if (!status) {
      toast.error(i18n.t("flowBuilder.editor.nodes.ticketStatus.noStatusSelected"));
      return;
    }
    
    if (node?.id && onUpdate) {
      onUpdate({
        ...node,
        data: {
          ...node.data,
          name: name,
          status: status
        }
      });
    } else {
      onSave({
        ...node?.data,
        name: name,
        status: status
      });
    }
    
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className={classes.title}>
        {i18n.t("flowBuilder.editor.nodes.ticketStatus.name")}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              {i18n.t("flowBuilder.editor.nodes.ticketStatus.nodeName")}
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          
          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              {i18n.t("flowBuilder.editor.nodes.ticketStatus.statusLabel") || "Estado a Cambiar"}
            </Typography>
            <Select
              fullWidth
              variant="outlined"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <MenuItem value="open">{i18n.t("flowBuilder.editor.nodes.ticketStatus.status.open") || "Abierto"}</MenuItem>
              <MenuItem value="closed">{i18n.t("flowBuilder.editor.nodes.ticketStatus.status.closed") || "Cerrado"}</MenuItem>
              <MenuItem value="pending">{i18n.t("flowBuilder.editor.nodes.ticketStatus.status.pending") || "Pendiente"}</MenuItem>
            </Select>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          {i18n.t("flowBuilder.editor.nodes.ticketStatus.cancel") || "Cancelar"}
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          {i18n.t("flowBuilder.editor.nodes.ticketStatus.save") || "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
